module.exports = __webpack_public_path__ + "micon.c77332f603c38a787040.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/assets/fonts/micon.woff2
// module id = ../../../../../src/assets/fonts/micon.woff2
// module chunks = styles